import React from "react"

class BarColor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
      ...props
    }

    this.togglePrioritySelector = this.togglePrioritySelector.bind(this)
  }

  togglePrioritySelector() {
    this.setState({ show: !this.state.show })
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.priority != nextProps.priority) {
      fetch(`/admin/loans/${this.state.appNumber}/update_pipeline`, {
        method: 'PUT',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': this.props.csrfToken,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: `{ "loan": { "priority": "${nextProps.priority}" } }`,
        credentials: 'same-origin'
      })
    }
    this.setState({ ...nextProps })
  }

  render() {
    const { show, priority, barColors } = this.state

    return(
      <div className={`bar-color ${priority}`} onClick={priority !== 'blue' ? this.togglePrioritySelector : undefined}>
        <div className={`selector ${show ? '' : 'hidden'}`}>
          { barColors.map(bar => 
              <div key={`${bar.color}bar`} className={`${bar.color}bar`} onClick={bar.proc}>
              </div>
            ) 
          }
        </div>
      </div>
    )
  }
}

export default BarColor;
